import { useMemo } from 'react'
import { useTheme } from '#app/routes/resources+/theme-switch'
import ResponsivePicture from './responsive-picture'

// Define your base image sources (Cloudinary will handle responsive variants)
const cosmicDarkSource = '/img/bg/cosmic_dark_mode_cloudinary_base.jpg'
const cosmicLightSource = '/img/bg/cosmic_light_mode_cloudinary_base.jpg'

export function StarryBackground() {
	const theme = useTheme()
	const isDark = useMemo(() => theme === 'dark', [theme])

	return (
		<div className="full-screen-bg pointer-events-none">
			<ResponsivePicture
				src={isDark ? cosmicDarkSource : cosmicLightSource}
				alt="Cosmic background with stars"
				width={2560}
				height={1440}
				isDark={isDark}
				loading="eager"
				quality={90}
				crop="fill"
				gravity="center"
				objectFit="cover"
				sizes="100vw"
				className="full-screen-bg"
			/>
		</div>
	)
}
